import Ticket from './Ticket';
import './Ticket.scss';

export default Ticket;
